var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wp-body"},[_c('div',{staticClass:"wp-header mb-4"},[_c('h1',{staticClass:"obj-name"},[_vm._v(_vm._s(_vm.$t('organizations')))])]),_c('TestTree')],1)}
var staticRenderFns = []

export { render, staticRenderFns }